import { Banner } from '@web_opxp/components';
import { FirebaseSelectors, RemoteConfigService } from '@web_opxp/features';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import * as ENV from '../base/env';
import { getRecruitmentLink } from '../base/utils';

export const RecruitmentBanner: FC = () => {
  const { language, t } = useTranslation();
  const isFirebaseReady = useSelector(FirebaseSelectors.isReady);
  if (!isFirebaseReady) {
    return null;
  }
  const show = RemoteConfigService.getBooleanConfigValue(ENV.RemoteConfigRecruitmentBanner, false);
  const content = renderStringToReact(t('prereg:RecruitmentBanner.TextHtml'), ETagType.span);
  const blogLink = getRecruitmentLink();
  return (
    <Banner show={show && language === 'de'}>
      <a href={blogLink}>{content}</a>
    </Banner>
  );
};

export default RecruitmentBanner;
